<div class="row ss-top-menu">
  <div class="col-sm-3">
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">Dashboard <i
        class="rightArrow fa fa-angle-right"></i></span>
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">Store List</span>
  </div>
  <div class="col-sm-9  text-right d-flex">
    <button class="downloadBtn btn mr-3" data-toggle="modal" data-target="#storeModal">
      Create New Store
    </button>
    <div class="ss-searchbox w-100">
      <i class="fa fa-search"></i>
      <input class="" type="text" placeholder="Search by Name or Type" [(ngModel)]="searchString">
    </div>
    <button class="addCursor h-100 ml-4 rk-interalBtnColor" (click)="searchLeadStore()">GO</button>
  </div>
</div>

<div class="rk-ui-notification" *ngIf="successalert">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="rk-ui-notification err" *ngIf="erroralert">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>

<div class="mt-4 container-set">
  <div class="row">
    <div class="col-md-12" *ngIf="store_que_arr && store_que_arr.length > 0">
      <div class="tableDiv table-responsive">
        <div class="tableDiv">

          <table class="table">
            <thead>
              <tr>
                <th class="text-center firstTh">#</th>
                <th>Store Name</th>
                <th>Address</th>
                <th>Type</th>
                <th>Commission</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let data of store_que_arr | paginate
          : {
            itemsPerPage: per_page,
            currentPage: current_page,
            totalItems: total_page
          }  ;let i = index "
                [attr.data-index]="i">               
                <td class="text-center">{{current_page*10+i+1-10}}</td>              
                <td class="" style="width: 18%;">{{data.name}}</td>
                <td class="capitalize minWidthForTd" style="width: 40%;">
                  {{ data.address}}
                </td>
                <td class="minWidthForTd">{{data.stype}}</td>
                <td>{{data.commission}}%</td>
                <td class="text-center">
                  <button class="downloadBtn btn" (click)="updateLeadStore(data.id)" data-toggle="modal"
                    data-target="#storeModal">
                    <i class="fa fa-pencil"></i> 
                    <!-- Edit -->
                  </button>
                  <button class="downloadBtn btn ml-3" (click)="deleteStoreDetails(data.id)">
                    <i class="fa fa-trash"></i> 
                    <!-- Delete -->
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center">
  <pagination-controls autoHide="true"(pageChange)="current_page = getStoreList($event)" ></pagination-controls>
 </div>
        </div>
        <!-- <div class="text-center" *ngIf="store_que_arr && store_que_arr.length >0">
          <pagination-controls autoHide="true" (pageChange)="navigateToPage($event);current_page = getStoreList($event,searchValue);">
          </pagination-controls>
        </div> -->
      </div>
    </div>
    <div class="col-md-12 not-found " *ngIf="store_que_arr && store_que_arr.length==0 ">
      <div class="boq-img text-center">
        <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
      </div>
      <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">No Lead Store to display...</p>
    </div>
  </div>
</div>


<!-- The Modal -->
<app-save-store-data class="modal fade" id="storeModal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="leadDetailsModalTitle" aria-hidden="true" (sendSubmitStoreEvent)="handleStoreCreateEvent($event)" [store_id]="store_id" (sendCloseEvent)="handleCloseEvent()"></app-save-store-data>



// WEBPACK FOOTER //
// ./src/app/platform/organisation/store-mgmt/store-mgmt.component.html